module.exports = __webpack_public_path__ + "media/de_de_s1_Adelie.23e51d7c.mp3";